import React from 'react';

// The component now accepts 'status' and 'dueDate'
const InvoiceStatusBadge = ({ status, dueDate }) => {
  let displayStatus = status;
  
  // --- This is the new logic for "Overdue" ---
  // If the invoice is 'open' and a due date exists...
  if (status === 'open' && dueDate) {
    const today = new Date();
    const dueDateObj = new Date(dueDate);
    // Set hours to 0 to compare dates only, not times
    today.setHours(0, 0, 0, 0); 
    
    // If today is after the due date, we override the display status.
    if (today > dueDateObj) {
      displayStatus = 'overdue';
    }
  }

  // The style map now includes 'open' and 'overdue'.
  const statusStyles = {
    paid: {
      background: 'var(--Green-100)',
      color: 'var(--Green-700)',
    },
    open: {
      background: 'var(--Amber-100)',
      color: 'var(--Amber-700)',
    },
    overdue: {
      background: 'var(--Red-100)',
      color: 'var(--Red-700)',
    },
    draft: {
      background: 'var(--Grey-100)',
      color: 'var(--Grey-800)',
    },
  };

  const lowerCaseStatus = displayStatus.toLowerCase();
  const badgeStyle = statusStyles[lowerCaseStatus] || statusStyles.draft;

  return (
    <span
      className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full"
      style={badgeStyle}
    >
      {lowerCaseStatus.charAt(0).toUpperCase() + lowerCaseStatus.slice(1)}
    </span>
  );
};

export default InvoiceStatusBadge;
